import React, { useReducer } from 'react'
import { PositionContext } from '../context'
import { positionReducer, initialState } from '../reducer/positionReducer'

/*
 * Copyright 2022-08-24 por miguel balloqui Ecomsur Holding S.A ©
 * Detalle:
 */

export const PositionProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(positionReducer, initialState)

  const value = { state, dispatch }

  return (
    <PositionContext.Provider value={value}>
      {children}
    </PositionContext.Provider>
  )
}
